import React from 'react';
import { Btn } from '../Btn/Btn.jsx';
import { Toast } from '../Toast/Toast.jsx';

const h = React.createElement;

const bus = { list: [], subs: new Set(), emit() { this.subs.forEach((f) => f(this.list.slice())); } };

/**
 * Show a toast from anywhere. Returns its id. Needs <Toaster /> mounted once.
 *
 * @param {object} p
 * @param {React.ReactNode} p.msg
 * @param {'neutral'|'green'|'amber'|'red'} [p.tone]
 * @param {React.ReactNode} [p.stamp]
 * @param {{ label: string; onClick?: () => void }} [p.action]
 * @param {number} [p.duration]
 * @param {string|number} [p.id]
 */
export function toast(t) {
  const id = t.id || Date.now() + Math.random();
  const item = { id, tone: 'neutral', duration: t.action ? 8000 : 4200, ...t };
  bus.list = bus.list.filter((x) => x.id !== id).concat([item]).slice(-3);
  bus.emit();
  return id;
}

function ToastItem({ t }) {
  const hover = React.useRef(false), left = React.useRef(t.duration), last = React.useRef(Date.now());
  React.useEffect(() => { const iv = setInterval(() => { const now = Date.now(); if (!hover.current) left.current -= now - last.current; last.current = now; if (left.current <= 0) toast.dismiss(t.id); }, 200); return () => clearInterval(iv); }, []);
  return h('div', { onPointerEnter: () => { hover.current = true; }, onPointerLeave: () => { hover.current = false; } },
    h(Toast, { tone: t.tone, stamp: t.stamp, onClose: () => toast.dismiss(t.id), action: t.action ? h(Btn, { size: 'sm', onClick: () => { toast.dismiss(t.id); t.action.onClick && t.action.onClick(); } }, t.action.label) : null }, t.msg));
}

/**
 * @param {object} p
 * @param {number} [p.width]
 */
export function Toaster({ width = 360 }) {
  const [list, setList] = React.useState(bus.list);
  React.useEffect(() => { bus.subs.add(setList); return () => bus.subs.delete(setList); }, []);
  return h('div', { 'aria-live': 'polite', style: { position: 'fixed', right: 20, bottom: 20, zIndex: 95, display: 'flex', flexDirection: 'column', gap: 12, width, maxWidth: 'calc(100vw - 32px)' } }, list.map((t) => h(ToastItem, { key: t.id, t })));
}
toast.dismiss = (id) => { bus.list = bus.list.filter((x) => x.id !== id); bus.emit(); };
